export const RecaptchaCheckCase = async (token: string): Promise<any> => {
  try {
    const data = new FormData();
    data.append('token', token);

    const response = await fetch('/api/recaptcha', {
      method: 'POST',
      body: data,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};
